import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../../components/layout/layout';

export default function CGVPage() {
  return (
    <Layout>
      <Helmet>
        <title>Conditions générales de vente | recruteurs.io</title>
        <meta
          name="description"
          content="Conditions générales de vente de recruteurs.io : prestations de recrutement, modalités de commande, tarifs, paiement et droit applicable."
        />
        <link rel="canonical" href="https://recruteurs.io/legal/cgv/" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="container-custom max-w-3xl py-16">
        <h1 className="text-4xl font-bold mb-10 text-neutral-900">Conditions générales de vente</h1>

        <p className="text-neutral-600 leading-relaxed mb-10">
          Les présentes conditions générales de vente (CGV) régissent les relations contractuelles entre <strong>LOOCATME</strong> (ci-après « recruteurs.io »), 11 chemin du Mont Gibaou, 13260 Cassis, France, SIRET 832 172 506, et toute personne morale ou physique (ci-après « le Client ») souhaitant bénéficier des services proposés sur le site <strong>recruteurs.io</strong>.<br /><br />
          Toute commande implique l'acceptation pleine et entière des présentes CGV.
        </p>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">1. Objet</h2>
          <p className="text-neutral-600 leading-relaxed">
            Les présentes CGV ont pour objet de définir les conditions dans lesquelles recruteurs.io fournit au Client des prestations de conseil et d'accompagnement en recrutement, externalisation RH, stratégie de marque employeur et outils IA RH, telles que décrites sur le site et dans les propositions commerciales émises.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">2. Prestations</h2>
          <p className="text-neutral-600 leading-relaxed mb-3">Les prestations proposées incluent notamment :</p>
          <ul className="list-disc list-inside text-neutral-600 space-y-2 leading-relaxed">
            <li>Recrutement de cadres et profils spécialisés (approche directe, sourcing, évaluation).</li>
            <li>Campagnes de recrutement (funnel RH, ciblage, intégration candidat).</li>
            <li>Externalisation RH partielle ou totale.</li>
            <li>Conseil en stratégie RH et IA RH.</li>
            <li>Accès à des outils en ligne (PimpMyJob, Atterrissage RH, etc.).</li>
          </ul>
          <p className="text-neutral-600 leading-relaxed mt-3">
            Le détail et le périmètre exact de chaque prestation sont définis dans la proposition commerciale et/ou le bon de commande signé entre les parties.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">3. Modalités de commande</h2>
          <p className="text-neutral-600 leading-relaxed">
            Toute commande est formalisée par l'acceptation écrite (e-mail ou signature électronique) d'une proposition commerciale émise par recruteurs.io. À réception de l'accord du Client, recruteurs.io adresse une confirmation de commande et, le cas échéant, une facture d'acompte.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">4. Prix</h2>
          <p className="text-neutral-600 leading-relaxed">
            Les prix sont indiqués en euros hors taxes (HT). Ils sont fixés dans la proposition commerciale et peuvent varier selon la complexité de la mission, le niveau du poste et la formule choisie. recruteurs.io se réserve le droit de modifier ses tarifs à tout moment ; toutefois, les prestations commandées sont facturées au prix en vigueur au moment de la commande.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">5. Paiement</h2>
          <p className="text-neutral-600 leading-relaxed">
            Sauf conditions particulières mentionnées dans la proposition commerciale, les conditions de paiement sont les suivantes :<br /><br />
            — Acompte à la commande : 30 % % du montant HT.<br />
            — Solde : à la présentation du/des candidat(s) retenu(s) ou à la date définie dans la proposition.<br /><br />
            Les factures sont payables à 30 jours jours à compter de leur date d'émission. Tout retard de paiement entraîne l'application de pénalités de retard au taux légal en vigueur, ainsi qu'une indemnité forfaitaire de recouvrement de 40 € (art. L.441-10 du Code de commerce).
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">6. Garantie et remplacement</h2>
          <p className="text-neutral-600 leading-relaxed">
            Selon la formule souscrite, recruteurs.io peut proposer une garantie de remplacement en cas de rupture de période d'essai (hors faute du candidat ou du Client). Les conditions et durées de garantie sont précisées dans la proposition commerciale.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">7. Obligations du Client</h2>
          <p className="text-neutral-600 leading-relaxed">
            Le Client s'engage à fournir à recruteurs.io toutes les informations nécessaires à la bonne exécution de la mission (brief de poste, contraintes, calendrier), à répondre dans des délais raisonnables aux sollicitations de recruteurs.io, et à informer recruteurs.io de toute décision relative aux candidats présentés dans un délai de 5 jours ouvrés.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">8. Responsabilité</h2>
          <p className="text-neutral-600 leading-relaxed">
            recruteurs.io est tenu à une obligation de moyens. Sa responsabilité ne saurait être engagée en cas de force majeure, de fourniture d'informations inexactes par le Client, de refus du candidat d'accepter le poste, ou de tout événement indépendant de sa volonté. En tout état de cause, la responsabilité de recruteurs.io est limitée au montant des sommes versées au titre de la prestation concernée.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">9. Confidentialité</h2>
          <p className="text-neutral-600 leading-relaxed">
            Les parties s'engagent à traiter comme strictement confidentielles toutes les informations échangées dans le cadre de la mission. Cette obligation s'applique pendant toute la durée de la relation contractuelle et pour une période de 3 ans après son terme.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">10. Propriété intellectuelle</h2>
          <p className="text-neutral-600 leading-relaxed">
            Les méthodes, outils, livrables et contenus développés par recruteurs.io restent la propriété exclusive de LOOCATME, sauf disposition contraire expressément convenue par écrit. Le Client dispose d'une licence d'utilisation limitée aux finalités de la mission.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">11. Protection des données personnelles</h2>
          <p className="text-neutral-600 leading-relaxed">
            Dans le cadre de l'exécution des présentes, les parties peuvent être amenées à traiter des données personnelles de candidats. Chaque partie s'engage à traiter ces données dans le respect du RGPD. Les modalités détaillées figurent dans notre{' '}
            <a href="/legal/confidentialite" className="underline hover:text-[#d03484]">politique de confidentialité</a>.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">12. Résiliation</h2>
          <p className="text-neutral-600 leading-relaxed">
            En cas de manquement grave de l'une des parties à ses obligations contractuelles, l'autre partie pourra résilier le contrat de plein droit après mise en demeure restée sans effet pendant 15 jours ouvrés. Les sommes dues pour les prestations déjà réalisées restent exigibles.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">13. Droit applicable — Juridiction compétente</h2>
          <p className="text-neutral-600 leading-relaxed">
            Les présentes CGV sont soumises au droit français. En cas de litige, les parties s'efforceront de trouver une solution amiable. À défaut, le litige sera soumis à la compétence exclusive des tribunaux de Marseille.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">14. Contact</h2>
          <p className="text-neutral-600 leading-relaxed">
            Pour toute question relative aux présentes CGV :<br />
            E-mail : <a href="mailto:contact@recruteurs.io" className="underline hover:text-[#d03484]">contact@recruteurs.io</a><br />
            Adresse : 11 chemin du Mont Gibaou, 13260 Cassis, France
          </p>
        </section>

        <p className="text-sm text-neutral-400 mt-12">Dernière mise à jour : juillet 2026</p>
      </div>
    </Layout>
  );
}
